import { createFileRoute, notFound } from "@tanstack/react-router";
import { IMAGE_TABS, ImageDetail, type ImageTab } from "../../features/storage/image-detail";

export const Route = createFileRoute("/_authed/$org/$project/images/$name/$tab")({
  beforeLoad: ({ params }) => {
    if (!IMAGE_TABS.includes(params.tab as ImageTab)) throw notFound();
  },
  component: ImagePage,
});

function ImagePage() {
  const { org, project, name, tab } = Route.useParams();
  return <ImageDetail scope={{ org, project }} name={name} tab={tab as ImageTab} />;
}
